<template>
  <!-- 高考复读-明师教育 -->
  <div class="pc-bg"
       @scroll="scrollfn"
       ref="bigbox">
    <div class="pc-main"
         ref="main">
      <div v-for="(item, i) in imgList"
           :key="i"
           ref="img"
           class="pc-img-box">
        <img :src="item.img"
             class="pc-bgimg"
             v-if="item.show"
             :id="id(i)" />
        <!-- <div class="pc-box2"
             v-if="i===1">
          <swiper :options="swiperOption"
                  class="swiper">
            <swiper-slide v-for="(item,index) in banner"
                          :key="index"
                          class="swiper-slide">
              <img :src="item.img"
                   class="pc-img" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination"></div>
        </div> -->
      </div>
    </div>
    <div class="bottom"
         ref="bottom">
      <i>© 重本紫腾教育科技（广州）有限公司 版权所有。</i>
      <a class="beian"
         href="https://beian.miit.gov.cn">粤ICP备2021074338号</a>
      <!-- | 本公司荣获SGS的ISO9001:2008认证 | 增值电信业务经营许可证：粤B2-20170231 Copyright (C) 2002-2018 |
      <a class="beian"
         href="https://gdca.miit.gov.cn/">广东省通信管理局</a> -->
    </div>

    <!-- 锚点标签 -->
    <!-- <div class="none"
         v-for="(item, i) in fake"
         :key="i"
         :style="item.top"
         :id="id(i)">
    </div> -->
    <!-- <div class="box">
      <swiper :options="swiperOption"
              class="swiper">
        <swiper-slide v-for="(item,index) in slideData"
                      :key="index"
                      class="swiper-slide">
          <img :src="item.imgLink"
               class="img" />
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div> -->
    <!-- 选卡 -->
    <!-- <div class="clickbox">
      <div class="right">
        <img :src="selectData.imgLink">
      </div>
      <div class="left">
        <div :class="selectData.name==item.name?'selected option': 'option'"
             v-for="(item, i) in clickBox"
             :key="i"
             @click="selectData=item">{{item.name}}</div>
      </div>
    </div> -->
    <!-- <div class="box2">
      <swiper :options="swiperOption2"
              class="swiper2">
        <swiper-slide v-for="(item,index) in slideData2"
                      :key="index"
                      class="swiper-slide">
          <img :src="item.imgLink"
               class="img" />
        </swiper-slide>

      </swiper>
      <div class="swiper-pagination"></div>
    </div> -->
    <!-- 跳转活动 -->
    <!-- <div class="activity">
      <div class="act-main">
        <div class="activity-big"
             v-for="(item, i) in activity"
             :key="i">
          <div class="activity-small"
               v-for="(sitem, si) in item"
               :key="si"
               @click="goActivity(sitem)"></div>
        </div>
      </div>
      <div class="oneOnOne"
           @click="goActivity({link: 'https://jinshuju.net/f/xrJuRU'})"></div>
    </div> -->
    <!-- <div class="box3">
      <swiper :options="swiperOption3"
              class="swiper3">
        <swiper-slide v-for="(item,index) in slideData3"
                      :key="index"
                      class="swiper-slide">
          <img :src="item.imgLink"
               class="img" />
        </swiper-slide>

      </swiper>
      <div class="swiper-pagination"></div>
    </div> -->
    <!-- <a href="tel:18102803633"
       class="call"></a> -->
  </div>
</template>

<script>
export default {
  mounted () {
    document.title = "重本·紫腾     艺体生文化课"
  },
  data () {
    return {
      swiperOption: {
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        // 设置轮播
        // effect: 'flip',
        effect: 'slide',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        }
      },
      imgList: [
        {
          img: require('@/assets/img/art/PC-1.png'),
          show: true
        },
        {
          img: require('@/assets/img/art/PC-2.png'),
          show: true
        },
        {
          img: require('@/assets/img/art/PC-3.png'),
          show: false
        },
        {
          img: require('@/assets/img/art/PC-4.png'),
          show: false
        },
        {
          img: require('@/assets/img/art/PC-5.png'),
          show: false
        },
        {
          img: require('@/assets/img/art/PC-6.png'),
          show: false
        // },
        // {
        //   img: require('@/assets/img/art/7.png'),
        //   show: false
        // },
        // {
        //   img: require('@/assets/img/art/8.png'),
        //   show: false
        // },
        // {
        //   img: require('@/assets/img/art/9.png'),
        //   show: false
        }
      ],
      showNum: 2,
    }
  },
  methods: {
    scrollfn () {
      if (this.$refs.bigbox.scrollTop >= 755) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      if ((this.$refs.main.offsetHeight - (this.$refs.bigbox.scrollTop + this.$refs.bigbox.offsetHeight) + this.$refs.bottom.offsetHeight) < 50) {
        this.showNum++
        if (this.showNum >= this.imgList.length) return
        console.log(this.imgList)
        this.imgList[this.showNum].show = true
      }
    },
    goActivity (item) {
      if (item.link) {
        window.location.href = item.link
      }
    },
    id (id) {
      return 'No' + id
    },
    go (val, i) {
      document.querySelector(`#No${i}`).scrollIntoView(true)
    },
    goLink () {
      window.location.href = 'https://m.liangpinedu.cn/special/eventsgd/index.html?n=20210516jdyx#gwzxbmldy'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pc-bg {
  /* position: absolute; */
  /* left: 50%; */
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  /* margin: 0 auto;
    transform: translateX(-50%); */

  .pc-img-box {
    position: relative;
    width: 100%;
    height: auto;
    .pc-bgimg {
      display: block;
      width: 100%;
    }
    /* 定位的导航栏 */
    .pc-absoluteBox {
      position: absolute;
      top: 0;
      left: 50%;
      width: 39.58%;
      height: 100%;
      /* background-color: rgba(0, 0, 0, .5); */
      transform: translateX(-50%);
      box-sizing: border-box;

      .pc-fake-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        /* height: 70px; */
        /* padding: 0 15px; */
        box-sizing: border-box;

        .pc-fake {
          width: 21.5%;
          height: 100%;
        }
      }
    }
    /* 定位的导航栏 */
  }
}

  .box2{
    position: absolute;
    top: 5684px ;
    left: 50%;
    transform: translateX(-50%);
    width: 701px;
    height: 350px;
    border-radius: 20px;
    overflow: hidden;
  }
  .swiper2{
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    overflow: hidden;
  }
  .img {
    width: 100%;
  }
  .none {
    /* display: none; */
    position: absolute;
    left: 0;
    width: 100%;
    height: 0;
  }
  /* 定位的导航栏 */
  .absoluteBox {
    position: absolute;
    bottom: 2.0%;
    left: 50%;
    width: 50.4%;
    height: 3.2%;
    padding: 0 9%;
    /* background-color: rgba(0, 0, 0, .5); */
    transform: translateX(-50%);
    box-sizing: border-box;
  }

  /* .fixedBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 78px;
    background: url('../assets/img/fixed.png') no-repeat;
    background-size: 100%;
  } */
  
  .fake-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    /* height: 70px; */
    /* padding: 0 15px; */
    box-sizing: border-box;
  }

  .fake {
    width: 23%;
    height: 100%;
  }
  /* 定位的导航栏 */
  /* 跳转活动 */
  .activity {
    position: absolute;
    top: 6095px;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    height: 282px;
    /* background-color: rgba(0,0,0,.7); */
  }

  .act-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .activity-big {
    display: flex;
    width: 340px;
    height: 98px;
    margin-bottom: 20px;
    border-radius: 15px;
    overflow: hidden;
  }

  .activity-small {
    width: 50%;
    height: 100%;
  }

  .oneOnOne {
    width: 100%;
    height: 46px;
    border-radius: 21px;
  }
  /* 跳转活动 */
  .box3 {
    position: absolute;
    top: 6600px;
    left: 50%;
    transform: translateX(-50%);
    width: 701px;
    height: 300px;
    border-radius: 20px;
    overflow: hidden;
  }
  .swiper3{
    width: 100%;
    height: 100%;
  }
  
  .swiper-pagination{
    position: absolute;
    bottom: 0;
    right: 0;
  }

  #btn {
    position: fixed;
    top: 500px;
    right: 30px;
  }

  .clickbox {
    position: absolute;
    top: 3938px;
    left: 50%;
    transform: translateX(-50%);
    width: 701px;
    height: 350px;
    border-radius: 20px;
    overflow: hidden;
  }

  .right {
    width: 100%;
    height: 100%;
  }

  .right > img {
    width: 100%;
    object-fit: fill;
  }

  .left {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 46px;
  }

  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33.3%;
    height: 100%;
    font-size: 20px;;
    color: #666666;
    background: #E2E2E2;
  }

  .selected {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33.3%;
    height: 100%;
    font-size: 20px;
    color: #fff;
    background: #DB4527;
  }

  .call {
    position: absolute;
    top: 8599px;
    left: 640px;
    display: block;
    width: 390px;
    height: 40px;
  }

  .bottom {
    width: 100%;
    height: 30px;
    /* padding-bottom: 80px; */
    font-size: 14px;
    line-height: 30px;
    color: #999;
    text-align: center;
    background-color: #4a4a4a;
  }

  .beian {
    color: #999;
    text-decoration: none;
  }

  .beian:hover {
    text-decoration: underline;
  }
</style>
<style>
.my-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: #b2aba1;
  border-radius: 50%;
  opacity: .4;
}

.my-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/art.vue